
const FIXED_HOLIDAYS: { month: number; day: number }[] = [
  { month: 1, day: 1 },
  { month: 5, day: 1 },
  { month: 5, day: 8 },
  { month: 7, day: 5 },
  { month: 7, day: 6 },
  { month: 9, day: 28 },
  { month: 10, day: 28 },
  { month: 11, day: 17 },
  { month: 12, day: 24 },
  { month: 12, day: 25 },
  { month: 12, day: 26 },
]

export function isCzechHoliday(date: Date): boolean {
  const month = date.getMonth() + 1
  const day = date.getDate()
  return FIXED_HOLIDAYS.some((h) => h.month === month && h.day === day)
}

export function isWeekend(date: Date): boolean {
  const dow = date.getDay()
  return dow === 0 || dow === 6
}

export function isWorkingDay(date: Date): boolean {
  return !isWeekend(date) && !isCzechHoliday(date)
}
